import type { FeedbackChatMessage } from '@/services/feedback-chat-api'

export const CHAT_MAX_CHARS = 4000
export const CHAT_POLL_INTERVAL_MS = 15_000
export const SUPPORT_TEAM_NAME = 'Sensei Destek'

const TITLE_MAX = 60

/** Ekip mesajı etiketi: "Sensei Destek · Kadir"; yazan adı yoksa yalnız "Sensei Destek". */
export function teamLabel(author: string | null | undefined): string {
  const name = author?.trim()
  return name ? `${SUPPORT_TEAM_NAME} · ${name}` : SUPPORT_TEAM_NAME
}

export function formatMessageTime(value: string): string {
  const date = new Date(value)
  if (Number.isNaN(date.getTime())) return ''
  return new Intl.DateTimeFormat('tr-TR', { hour: '2-digit', minute: '2-digit' }).format(date)
}

function dayKey(date: Date): string {
  return `${date.getFullYear()}-${date.getMonth()}-${date.getDate()}`
}

export function formatDayLabel(value: string, now: Date = new Date()): string {
  const date = new Date(value)
  if (Number.isNaN(date.getTime())) return ''
  if (dayKey(date) === dayKey(now)) return 'Bugün'
  const yesterday = new Date(now)
  yesterday.setDate(now.getDate() - 1)
  if (dayKey(date) === dayKey(yesterday)) return 'Dün'
  return new Intl.DateTimeFormat('tr-TR', { day: 'numeric', month: 'long', year: 'numeric' }).format(date)
}

export type ChatListEntry =
  | { kind: 'day'; key: string; label: string }
  | { kind: 'message'; key: string; message: FeedbackChatMessage }

/** Mesajları gün ayraçlarıyla birlikte düz bir listeye çevirir. */
export function buildChatEntries(messages: FeedbackChatMessage[], now: Date = new Date()): ChatListEntry[] {
  const entries: ChatListEntry[] = []
  let lastDay = ''
  for (const message of messages) {
    const date = new Date(message.createdAt)
    const key = Number.isNaN(date.getTime()) ? '' : dayKey(date)
    if (key && key !== lastDay) {
      entries.push({ kind: 'day', key: `day-${key}`, label: formatDayLabel(message.createdAt, now) })
      lastDay = key
    }
    entries.push({ kind: 'message', key: message.id, message })
  }
  return entries
}

/** Sohbet başlığı: bildirimin ilk kullanıcı mesajının ilk satırı (kısaltılmış). */
export function deriveChatTitle(messages: FeedbackChatMessage[]): string {
  const first = messages.find((message) => message.from === 'user' && message.body.trim())
  if (!first) return 'Destek sohbeti'
  const line = first.body.trim().split(/\r?\n/, 1)[0]
  return line.length > TITLE_MAX ? `${line.slice(0, TITLE_MAX - 1)}…` : line
}

export function latestTeamMessageId(messages: FeedbackChatMessage[]): string | null {
  for (let index = messages.length - 1; index >= 0; index -= 1) {
    if (messages[index].from === 'team') return messages[index].id
  }
  return null
}
